import React from 'react';
import StatusBasedProjects from './StatusBasedProjects';

const SignPendingProjects = () => {
  return (
    <StatusBasedProjects 
      status="SIGNPENDING"
      title="Sign Pending Projects"
    />
  );
};

export default SignPendingProjects;